/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export var STATE_CHANGE_TYPE = {
  expand: 'expand'
};